import BossModel from "@/models/BossModel";
import Country from "@/models/Country/Country";
import PublicImage from "@/models/PublicImage/PublicImage";
import Target from "@/models/Airline/Target/Target";

export default class Airline extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'airline';

    /**
     *
     * @type {string}
     */
    static entity = 'airlines';

    static fields() {
		return {
			id: this.number(null).nullable(),
			code: this.attr(null),
			name: this.attr(null),
			country_id: this.number(null).nullable(),
			is_active: this.boolean(null),
            is_flight_sfi_required: this.boolean(null),
			afas_verbation_code: this.attr(null),
			public_image_id: this.number(null).nullable(),
            country: this.belongsTo(Country, 'country_id'),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
            Targets: this.hasMany(Target, 'airline_id'),
		}
	}

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get().then((data) => {
            let airlines = [];
            for (let key in data) {
                airlines.push(new Airline(data[key]));
            }
            return airlines;
        });
    }
}
